<template>
  <div class="seismo-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$F_inertial = -m·a$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage light-stage" @mousedown="isShaking = true" @mouseup="isShaking = false">
        <div class="hud-panel">
          <div class="hud-item rose">
             <label>地面加速度 a</label>
             <span class="val">{{ currentAcc.toFixed(2) }} m/s²</span>
          </div>
          <div class="hud-item emerald">
             <label>惯性静止坐标</label>
             <span class="val">重锤轨迹 (相对)</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 600 240" preserveAspectRatio="xMidYMid meet">
          <!-- 地震仪支架 (随地面抖动) -->
          <g :transform="`translate(${shakeX}, 0)`">
            <!-- 支架底部 -->
            <rect x="100" y="210" width="400" height="20" fill="#334155" />
            <!-- 支架支柱 -->
            <rect x="150" y="40" width="10" height="170" fill="#64748b" />
            <rect x="150" y="40" width="120" height="10" fill="#64748b" />
            
            <!-- 滚动示数纸 (随架子动) -->
            <rect x="300" y="100" width="200" height="80" fill="#fff" stroke="#e2e8f0" />
            <path :d="paperPath" fill="none" stroke="#f43f5e" stroke-width="1.5" />
          </g>

          <!-- 惯性重锤 (由于惯性尽可能保持静止) -->
          <g :transform="`translate(${pendulumX}, 100)`">
             <line x1="0" y1="-50" x2="0" y2="40" stroke="#1e293b" stroke-width="2" />
             <circle cx="0" cy="40" r="18" fill="#1e293b" />
             <path d="M 0,40 L 40,40" stroke="#475569" stroke-width="1" stroke-dasharray="2,2" />
             <!-- 记录笔尖 -->
             <circle cx="40" cy="40" r="3" fill="#f43f5e" />
          </g>
        </svg>

        <div class="physics-caption">
          <strong>物理规律：</strong>由于重锤质量巨大且与支架间摩擦极小，当发生地震（支架剧烈晃动）时，重锤倾向于<strong>通过惯性保持其原本的静止状态</strong>。记录笔在此时会相对于随地面晃动的纸卷上留下载荷轨迹。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row">
             <span class="label">模拟地震震级 (震感强度)</span>
             <el-slider v-model="intensity" :min="0" :max="10" :step="0.1" size="small"></el-slider>
           </div>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-warning-outline"></i>
           <p><strong>实战物理：</strong>这也是重力勘探和潜艇惯性导航的基础。<strong>观察：</strong>点击屏幕并在左右拖动时模拟地震。虽然支架（灰色）和纸张（白色）在剧烈晃动，但重锤（黑色）动作幅度极小，正是这种“反差”记录下了地震的信息。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'SeismographPrincipleViz',
  data() {
    return {
      intensity: 3.5,
      shakeX: 0,
      pendulumX: 250, // 初始位置
      paperValues: [], // 存储相对位移
      time: 0,
      currentAcc: 0,
      isShaking: false
    }
  },
  computed: {
    paperPath() {
       if (this.paperValues.length < 2) return '';
       const width = 200;
       const xStep = width / 50;
       return 'M ' + this.paperValues.map((v, i) => {
          return `${300 + i * xStep}, ${140 + v * 2}`;
       }).join(' L ');
    }
  },
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
       requestAnimationFrame(this.animate);
       this.time += 0.1;
       
       // 模拟地震正弦波
       const amp = this.intensity * 5;
       const freq = 1.5;
       this.shakeX = Math.sin(this.time * freq) * amp;
       
       // 计算地面加速度 a = -Aω²sin(ωt)
       this.currentAcc = Math.abs(-amp * Math.pow(freq, 2) * Math.sin(this.time * freq)) / 10;

       // 惯性系简易模拟：重锤位置滞后且平滑
       const targetX = 250; 
       this.pendulumX += (targetX - this.pendulumX) * 0.05; // 模拟软连接
       
       // 记录相对位移
       const relativeY = this.shakeX - (this.pendulumX - 250);
       this.paperValues.push(relativeY);
       if (this.paperValues.length > 50) this.paperValues.shift();
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.seismo-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
